export const customed = {
  'color': [
    '#4183D7',
    '#8f82ea',
    '#deafe2',
    '#b27661',
    '#df73a8',
    '#f5b39f',
    '#F5E42E',
    '#cef780',
    '#93e0c6',
    '#90dcf8',
    '#546570'
  ],
  'grid': {
    'top': 0,
    'left': 0,
    'right': 0,
    'bottom': 1
  },
  'textStyle': {},
  'line': {
    'itemStyle': {
      'normal': {
        'borderWidth': 2
      }
    },
    'lineStyle': {
      'width': 1.5
    },
    'symbolSize': 5,
    'symbol': 'circle',
    'smooth': false,
    'hoverAnimation': false
  },
  'bar': {
    'itemStyle': {
      'normal': {
        'barBorderWidth': 0,
        'barBorderColor': '#ccc'
      },
      'emphasis': {
        'barBorderWidth': 0,
        'barBorderColor': '#ccc'
      }
    }
  },
  'categoryAxis': {
    'axisLine': {
      'show': false,
      'lineStyle': {
        'color': '#ccc'
      }
    },
    'axisTick': {
      'show': false,
      'lineStyle': {
        'color': '#ccc'
      }
    },
    'axisLabel': {
      'show': true,
      'textStyle': {
        'color': '#606266'
      }
    },
    'splitLine': {
      'show': false,
      'lineStyle': {
        'color': [
          '#ccc'
        ]
      }
    },
    'splitArea': {
      'show': false,
      'areaStyle': {
        'color': [
          'rgba(250,250,250,0.3)',
          'rgba(200,200,200,0.3)'
        ]
      }
    }
  },
  'valueAxis': {
    'axisLine': {
      'show': false,
      'lineStyle': {
        'color': '#ccc'
      }
    },
    'axisTick': {
      'show': false,
      'lineStyle': {
        'color': '#ccc'
      }
    },
    'axisLabel': {
      'show': true,
      'textStyle': {
        'color': '#606266'
      }
    },
    'splitLine': {
      'show': true,
      'lineStyle': {
        'color': [
          'rgba(204,204,204,0.15)'
        ]
      }
    },
    'splitArea': {
      'show': false,
      'areaStyle': {
        'color': [
          'rgba(250,250,250,0.3)',
          'rgba(200,200,200,0.3)'
        ]
      }
    }
  },
  'toolbox': {
    'iconStyle': {
      'normal': {
        'borderColor': '#a7a7a8'
      },
      'emphasis': {
        'borderColor': '#525252'
      }
    }
  },
  'legend': {
    'textStyle': {
      'color': '#606266'
    }
  },
  'tooltip': {
    'backgroundColor': 'rgba(255, 255, 255, .4)',
    'extraCssText': 'border-radius: 2px;',
    'axisPointer': {
      'shadowStyle': {
        'color': 'rgba(255, 255, 255, .1)'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/chart/customed.js